export const RGB = {
  UPDATE_PAYMENT_STATUS: 'UPDATE_PAYMENT_STATUS',
  UPDATE_PAYMENT_STATUS_SUCCESS: 'UPDATE_PAYMENT_STATUS_SUCCESS',
  UPDATE_PAYMENT_STATUS_FAIL: 'UPDATE_PAYMENT_STATUS_FAIL'
};
